import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from '@mui/material';
export const SectionHeader = ({ label, title, subtitle, footnote, maxWidth = 600, marginBottom, align = 'center', }) => {
    const theme = useTheme();
    const isLeft = align === 'left';
    return (_jsxs(Box, { sx: { textAlign: align, mb: marginBottom ?? { xs: 8, md: 12 } }, children: [label && (_jsx(Typography, { variant: "subtitle1", color: theme.palette.secondary.dark, sx: { mb: 4, display: 'block' }, children: label })), _jsx(Typography, { variant: "h1", sx: { mb: subtitle ? 4 : 0, fontSize: { xs: '24px', sm: '28px', md: '36px' } }, children: title }), subtitle && (_jsx(Typography, { variant: "subtitle2", color: "text.secondary", sx: { maxWidth, mx: isLeft ? 0 : 'auto', fontSize: '16px', fontWeight: 400, lineHeight: 1.5 }, children: subtitle })), footnote && (_jsx(Typography, { variant: "caption", sx: {
                    display: 'block',
                    mt: 2,
                    color: theme.palette.text.disabled,
                    fontStyle: 'italic',
                    fontSize: '12px',
                }, children: footnote }))] }));
};
